import z from 'zod';
import { SalesItemHistoryEntrySchema } from './SalesItemHistoryEntry';

export const SalesItemHistoryResultSchema = z.object({
    data: z.array(SalesItemHistoryEntrySchema),
    total: z.number(),
});

export type SalesItemHistoryResult = z.infer<typeof SalesItemHistoryResultSchema>;
